import { useRef } from "react";
import { motion, useMotionValue, useMotionTemplate } from "framer-motion";

export default function SpotlightCard({ children, className = "" }) {
  const ref = useRef(null);
  const x = useMotionValue(-500);
  const y = useMotionValue(-500);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    x.set(e.clientX - r.left);
    y.set(e.clientY - r.top);
  };

  const spotlight = useMotionTemplate`radial-gradient(340px circle at ${x}px ${y}px, rgba(0, 113, 227, 0.10), transparent 70%)`;

  return (
    <div ref={ref} onMouseMove={onMove} className={`relative overflow-hidden ${className}`}>
      <motion.div
        className="absolute inset-0 z-10 pointer-events-none"
        style={{ background: spotlight }}
      />
      {children}
    </div>
  );
}
